import React, { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Styles from './HelpLeftNavBar.module.scss';

const HelpLeftNavBar: FunctionComponent = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      <ul className={`list-unstyled ${Styles.listingWrapper}`}>
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle}`}>LOCATION HELP</li>
        <li className={`${path === '/help/browser-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/browser-settings">
            Step 1: Browser Settings
          </Link>
        </li>
        <li className={`${path === '/help/os-privacy-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/os-privacy-settings">
            Step 2: OS Privacy Settings
          </Link>
        </li>
        
        <li className={`fontSixteen text-black poppins-bold ${Styles.listingTitle} ${Styles.sectionSpacing}`}>NOTIFICATIONS</li>
        <li className={`${path === '/help/notification-settings' && Styles.active}`}>
          <Link className="fontFifteen poppins-regular text-decoration-none" to="/help/notification-settings">
            Turn Off Notifications
          </Link>
        </li>
      </ul>
    </>
  );
};

export default HelpLeftNavBar;